import React from "react";
import moment from "moment";
import { ChatModel } from "../models/index";
import { utils } from "../utils";
import EventEmitter, { Events } from "../services/eventemitter";
const processString = require("react-process-string");

class urlChecker {
    constructor() { }

    urlCheck(data: string, flag?) {
        var color = "rgb(173 173 173)"
        let stringWithLinks = data.replace("[NAVIGATEURL]", "");
        if (data?.includes("[NAVIGATEURL]") && flag) {
            color = "rgb(173 173 173)"
        }
        else {
            color = "rgb(255 255 255)"
        }

        let config = [
            {
                regex: /(http|https):\/\/(\S+)\.([a-z]{2,}?)(.*?)( |\,|$|\.)/gim,
                fn: (key, result) => (
                    <span key={key}>
                        {utils.isElectronBuild() ? (
                            <a
                                style={{ color: color, textDecoration: "underline" }}
                                target="_blank"
                                // href={`${result[1]}://${result[2]}.${result[3]}${result[4]}`}
                                onClick={() => openWindow(`${result[1]}://${result[2]}.${result[3]}${result[4]}`)}
                            >
                                {result[2]}.{result[3]}
                                {result[4]}
                            </a>
                        ) : (
                            <a
                                style={{ color: color, textDecoration: "underline" }}
                                target="_blank"
                                href={`${result[1]}://${result[2]}.${result[3]}${result[4]}`}
                            // onClick={() => openWindow(`${result[1]}://${result[2]}.${result[3]}${result[4]}`)}
                            >
                                {result[2]}.{result[3]}
                                {result[4]}
                            </a>
                        )}
                        {result[5]}
                    </span >
                ),
            },
            {
                regex: /(\S+)\.([a-z]{2,}?)(.*?)( |\,|$|\.)/gim,
                fn: (key, result) => (
                    <span key={key}>
                        {utils.isElectronBuild() ? (
                            <a
                                style={{ color: color, textDecoration: "underline" }}
                                target="_blank"
                                // href={`http://${result[1]}.${result[2]}${result[3]}`}
                                onClick={() => openWindow(`http://${result[1]}.${result[2]}${result[3]}`)}
                            >
                                {result[1]}.{result[2]}
                                {result[3]}
                            </a>
                        ) : (
                            <a
                                style={{ color: color, textDecoration: "underline" }}
                                target="_blank"
                                href={`http://${result[1]}.${result[2]}${result[3]}`}
                            // onClick={() => openWindow(`http://${result[1]}.${result[2]}${result[3]}`)}
                            >
                                {result[1]}.{result[2]}
                                {result[3]}
                            </a>
                        )}
                        {result[4]}
                    </span >
                ),
            },
        ];
        var processed = processString(config)(stringWithLinks);
        return processed;
    }
}

const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

const phoneRegex = /^\s*(?:\?(\d{0,5}))?[. (]*(\d{0,4})[. )]*(\d{2,5})[. ]*(\d{8,22})(?: *x(\d+))?\s*$/;

const zipCodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

const isValidPhonenumber = (value) => {
    return (/^\d{10,}$/).test(value?.replace(/[\s()+\-\/.]|ext/gi, ''));
}
const checkMaskingTypeEmail = (message: String) => {
    if (message) {
        var maskingMessage = message.split("@");
        maskingMessage[0] = "*******";
        var filterMessage = maskingMessage[0] + maskingMessage[1];
        return filterMessage;
    }
    return "";
};
const openWindow = (url) => {
    if (utils.isLoggedInResourcesScreenActive() && utils.isElectronBuild()) {
        window.myAPI.OpenVisitorLink(url);
    } else {
        EventEmitter.emit(Events.openNestedWindow, url);
    }
};

const checkMaskingTypePhone = (message: String) => {
    if (message) {
        return ('' + message).slice(0, -4)
            .replace(/./g, "*")
            + ('' + message).slice(-4);
    }        // var charArray = Array.from(message);
    // var msg = message;
    // for (let i = 0; i < message.length / 2; i++) {
    //     msg = msg?.replace(charArray[i], "*");
    // }
    // return msg;
    // }
    return "";
};

const getTimeForPreviousChat = (timeStamp) => {
    var finalTime;

    // if (timeStamp.includes("T")) {
    let localTime = moment.utc(timeStamp, "YYYY-MM-DD HH:mm:ss").local().format("YYYY-MM-DD HH:mm:ss");
    localTime = (localTime as any)?.split(" ")[1]?.split(":");
    let daynight = Number(localTime[0]) >= 12 ? "PM" : "AM";
    let hoursFormat = Number(localTime[0]) % 12 || 12;
    finalTime = hoursFormat + ":" + localTime[1] + ":" + localTime[2] + " " + daynight;
    return finalTime;
    // }
};

const convertTo12HourFormat = (timeStamp) => {
    // Parse the given timestamp using moment.js
    let localTime = moment(timeStamp).format("YYYY-MM-DD HH:mm:ss");
    // Split the local time to extract hours, minutes, and seconds
    localTime = localTime.split(" ")[1].split(":") as any;
    // Determine AM or PM
    let daynight = Number(localTime[0]) >= 12 ? "PM" : "AM";
    // Convert to 12-hour format, ensuring '0' hour becomes '12'
    let hoursFormat = Number(localTime[0]) % 12 || 12;
    // Combine the time parts into the final formatted time
    let finalTime = hoursFormat + ":" + localTime[1] + ":" + localTime[2] + " " + daynight;
    return finalTime;
}

const getTime = (timeStamp, convertable) => {
    if (timeStamp?.includes("T")) {
        return getTimeForPreviousChat(timeStamp);
    }

    var finalTime;
    if (timeStamp?.includes("/")) {
        let signalRDateFormat = timeStamp.substr(0, 19);
        timeStamp = moment.utc(signalRDateFormat).format("YYYY-MM-DD HH:mm:ss");
    }
    let time = (timeStamp as any)?.split(" ")[1]?.split(":");
    if (time != undefined) {
        let localTime = moment.utc(timeStamp, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
        // if (convertable) {
        //     localTime = moment.utc(timeStamp, "YYYY-MM-DD HH:mm:ss").local().format("YYYY-MM-DD HH:mm:ss");
        // }
        // else {
        //     localTime = moment.utc(timeStamp, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
        // }


        localTime = (localTime as any)?.split(" ")[1]?.split(":");
        let daynight = Number(localTime[0]) >= 12 ? "PM" : "AM";
        let hoursFormat = Number(localTime[0]) % 12 || 12;
        finalTime = hoursFormat + ":" + localTime[1] + ":" + localTime[2] + " " + daynight;

        return finalTime;
    }
};

const getWebsiteURL = (chat: ChatModel, characterLength): String => {

    if (chat.visitorInfo?.BT?.websiteurl) {
        var websiteurl = chat.visitorInfo?.BT.websiteurl;
        if (websiteurl?.length > characterLength) {
            return websiteurl.replace(/^https?\:\/\/?(?:www\.)?/i, "").slice(0, characterLength);
        } else {
            return websiteurl.replace(/^https?\:\/\/?(?:www\.)?/i, "");
        }
    } else if (chat.visitorInfo?.Info?.URL) {
        var url = chat.visitorInfo?.Info?.URL;
        if (url.length > characterLength) {
            return url.replace(/^https?\:\/\/?(?:www\.)?/i, "").slice(0, characterLength);
        } else {
            return url.replace(/^https?\:\/\/?(?:www\.)?/i, "");
        }
    } else if (chat.websiteTitle) {
        return chat.websiteTitle;
    } else {
        return "[Website Url Pending]";
    }
};

var URL = new urlChecker();

export { isValidPhonenumber, zipCodeRegex, URL, emailRegex, phoneRegex, getTime, checkMaskingTypeEmail, checkMaskingTypePhone, getWebsiteURL, getTimeForPreviousChat, convertTo12HourFormat };
